import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'

const Names = {
  fr: 'not-found',
  en: 'not-found'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  component: () => import('@page/notFound/NotFound.vue')
}

export { Config }
